import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import type { Moment } from 'moment'

interface Params {
  bookBy: Moment
  travelUntil: Moment
}

function getGiftingMessage(params: Params) {
  const { bookBy, travelUntil } = params

  return `Buy a package and send as a gift to a special someone. They can book by ${intlDateFormatter(bookBy.toDate(), INTL_DMY_CASUAL_FORMAT)} and travel until ${intlDateFormatter(travelUntil.toDate(), INTL_DMY_CASUAL_FORMAT)}.`
}

export default getGiftingMessage
